import { axios } from './config';

export const getTpVastsDoc = (siteId) => {
	return axios.get(`/cb/tpVasts/${siteId}`);
};

export const createTpVastsDoc = (payload) => {
	return axios.post(`/cb/tpVasts/`, payload);
};

export const updateTpVastsDoc = (payload) => {
	return axios.put(`/cb/tpVasts/`, payload);
};
